import axios from "axios";
import { notifySessionExpired } from "../utils/sessionExpiry";
//export const API_URL = 'http://localhost:3020'
export const API_URL = '/'
const API = axios.create({
    withCredentials: true,
    baseURL: API_URL,
})

// Global 401 handler: коли сесія протухла, бекенд відповідає 401 ("Не авторизований").
// Раніше це ловив лише useFetch — прямі виклики fetchFunction/API лишали користувача
// в "зомбі-сесії" (бачить помилку, але не викидається на екран логіну).
API.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error?.response?.status === 401) notifySessionExpired();
        return Promise.reject(error);
    }
);

export default API;